import React, { useState, useEffect, useRef } from 'react'
import styled from 'styled-components'

const FadeInSection = (props) => {
  const domRef = useRef()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => setIsVisible(entry.isIntersecting))
    })
    observer.observe(domRef.current)
  }, [])

  return (
    <Container axis={props.axis}>
      <div
        className={`fade-in-section ${isVisible ? 'is-visible' : ''}`}
        ref={domRef}
      >
        {props.children}
      </div>
    </Container>
  )
}

export default FadeInSection

export const Container = styled.div`
  .fade-in-section {
    opacity: 0;
    transform: ${(props) =>
      props.axis === 'x' ? 'translateX(20vh)' : 'translateY(20vh)'};
    visibility: hidden;
    transition: opacity 1200ms ease-out, transform 600ms ease-out,
      visibility 1200ms ease-out;
    will-change: opacity, transform, visibility;
  }

  .fade-in-section.is-visible {
    opacity: 1;
    transform: none;
    visibility: visible;
  }
`
